<script lang="ts">
  export let name: string = 'world';
  import { leSelf } from 'design/src/fonts/utheory-solfege';

  const { viewBoxInfo, path } = leSelf;
</script>

<h1 class="block border-2">Hello {name}!</h1>

<div>
  <input type="text" bind:value={name} />
  <br />
  <svg viewBox={viewBoxInfo.viewBoxString} style="fill: currentColor; border: 1px solid black;">
    <path d={path} />
  </svg>
</div>

<style global lang="postcss">
  @import '../app.postcss';
</style>
